<fc-search-many-input
  [label]="'STORAGES.LABEL' | translate"
  [control]="control"
  [search]="search"
  [displayWith]="displayWith"
></fc-search-many-input>
